import { Controller } from "@hotwired/stimulus";
import { searchPattern } from "./dropdown_component/search_pattern";

export default class extends Controller {
  static targets = ["all", "none", "item", "text", "search", "divider"];

  connect() {
    this.updateUI();
  }

  reset() {
    this.searchTarget.value = "";
    this.filter();
  }

  updatePlaceholder() {
    const count = this.itemTargets.filter((item) => item.checked).length;
    this.searchTarget.placeholder = `${count} of ${this.itemTargets.length} selected`;
  }

  selectAll() {
    this.noneTarget.checked = !this.allTarget.checked;
    this.itemTargets.forEach((item) => (item.checked = this.allTarget.checked));
    this.updatePlaceholder();
  }

  selectNone() {
    this.allTarget.checked = !this.noneTarget.checked;
    this.itemTargets.forEach(
      (item) => (item.checked = !this.noneTarget.checked),
    );
    this.updatePlaceholder();
  }

  filter() {
    this.itemTargets.forEach((item) =>
      item.parentElement.parentElement.parentElement.classList.remove("hidden"),
    );

    if (this.searchTarget.value.length > 1) {
      this.allTarget.parentElement.parentElement.parentElement.classList.add(
        "hidden",
      );
      this.noneTarget.parentElement.parentElement.parentElement.classList.add(
        "hidden",
      );
      this.dividerTarget.classList.add("hidden");
      const pattern = searchPattern(this.searchTarget.value);
      this.textTargets
        .filter((item) => !pattern.test(item.textContent))
        .forEach((item) =>
          item.parentElement.parentElement.parentElement.classList.add(
            "hidden",
          ),
        );
    } else {
      this.allTarget.parentElement.parentElement.parentElement.classList.remove(
        "hidden",
      );
      this.noneTarget.parentElement.parentElement.parentElement.classList.remove(
        "hidden",
      );
      this.dividerTarget.classList.remove("hidden");
    }
  }

  updateUI() {
    if (this.itemTargets.every((item) => item.checked)) {
      this.allTarget.checked = true;
      this.noneTarget.checked = false;
    } else if (this.itemTargets.every((item) => !item.checked)) {
      this.allTarget.checked = false;
      this.noneTarget.checked = true;
    } else {
      this.allTarget.checked = false;
      this.noneTarget.checked = false;
    }
    this.updatePlaceholder();
  }
}
